import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="reset-password"
export default class extends Controller {
  static targets = ["status", "checkbox"];

  connect() {
    if (!this.hasStatusTarget) return;

    this.initialActive = this.isActive();
  }

  isActive() {
    const t = this.statusTarget;
    return t.type === "checkbox" ? t.checked : t.value === "true";
  }

  toggle() {
    if (!this.hasCheckboxTarget) return;

    if (!this.initialActive && this.isActive()) {
      this.checkboxTarget.checked = true;
      this.checkboxTarget.disabled = true;
      this.checkboxTarget
        .closest("label")
        ?.classList.add("opacity-50", "pointer-events-none");
    } else if (!this.isActive()) {
      this.checkboxTarget.checked = false;
      this.checkboxTarget.disabled = false;
      this.checkboxTarget
        .closest("label")
        ?.classList.remove("opacity-50", "pointer-events-none");
    }
  }
}
